import { memo } from 'react'

import HeaderOverhaul from '@/components/elements/headerOverhaul'

import DualPicturesImage from './dualPicturesImage'

const DualPictures = ({ data }) => {
  const { header, images } = data

  return (
    <div className="dual-pictures-wrapper">
      <div className="dual-pictures-content">
        <HeaderOverhaul darkBackground header={header} className="dual-pictures-header" />
        <div className="dual-pictures-container">
          {images.data &&
            images.data.map((image, index) => (
              <DualPicturesImage key={image.id} image={image} index={index} />
            ))}
        </div>
      </div>
    </div>
  )
}

export default memo(DualPictures)
